/**
 * Points Rank V2 — 用户会员等级状态（标题 / 当前等级 / 积分 / 进度条）
 * - 文案：window.PRV2_I18N（Liquid i18n）
 * - 数据：/a/ores/points（与 my-points-v2 / points-details-v2 同源）
 * - 字段：enableEngagementLevel、engagementLevel、engagementLevelName、isHighestEngagementLevel、
 *         currentEngagementScores、nextLevelMinScore、scoreToNextLevel、levelStrategy
 * - levelStrategy 兜底：后端删减等级或 progress 字段为空时，按策略与分值推导等级与进度
 * - 数据就绪后派发 prr2:rank-updated，供 points-rank-rules-v2 高亮当前列
 */
(function () {
  /** 样式调试时可设为 true；联调完成后改为 false */
  var USE_MOCK_RANK = false;

  var MOCK_RANK_RESPONSE = {
    result: 1,
    data: {
      enableEngagementLevel: true,
      engagementLevel: 2,
      engagementLevelName: 'L2',
      isHighestEngagementLevel: false,
      currentEngagementScores: 450,
      nextLevelMinScore: 550,
      scoreToNextLevel: 100,
      points: 20047,
      expiredPoints: 0,
      list: [],
    },
  };

  var POINTS_API = '/a/ores/points?page=1&status=all&size=10';
  var RANK_UPDATED_EVENT = 'prr2:rank-updated';

  function fetchPointsData() {
    if (window.PointsPageAPI && window.PointsPageAPI.fetchBootstrap) {
      return window.PointsPageAPI.fetchBootstrap();
    }
    return fetch(POINTS_API, { credentials: 'same-origin' })
      .then(function (res) {
        return res.json();
      })
      .then(function (json) {
        return json && json.data;
      });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function toNumber(value) {
    var num = Number(value);
    return Number.isFinite(num) ? num : 0;
  }

  function isTruthyFlag(value) {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  function escapeHtml(s) {
    if (s == null) return '';
    var d = document.createElement('div');
    d.textContent = String(s);
    return d.innerHTML;
  }

  function normalizeLevelStrategy(raw) {
    var strategy = raw.levelStrategy;
    if (!Array.isArray(strategy) || !strategy.length) return null;

    return strategy
      .map(function (item) {
        return {
          levelNo: toNumber(item.levelNo),
          levelName: item.levelName != null ? String(item.levelName).trim() : '',
          minScore: toNumber(item.minScore),
        };
      })
      .filter(function (item) {
        return item.levelNo > 0;
      })
      .sort(function (a, b) {
        return a.levelNo - b.levelNo;
      });
  }

  function findLevelEntry(levels, levelNo) {
    for (var i = 0; i < levels.length; i += 1) {
      if (levels[i].levelNo === levelNo) return levels[i];
    }
    return null;
  }

  function resolveLevelByScore(levels, score) {
    var resolved = levels[0];
    for (var i = 0; i < levels.length; i += 1) {
      if (score >= levels[i].minScore) resolved = levels[i];
    }
    return resolved;
  }

  function findLevelIndex(levels, levelNo) {
    for (var i = 0; i < levels.length; i += 1) {
      if (levels[i].levelNo === levelNo) return i;
    }
    return -1;
  }

  /** 后端删减等级或 progress 字段缺失时，用 levelStrategy + 当前分值推导 */
  function deriveRankFromStrategy(raw, levels) {
    var score = toNumber(
      raw.currentEngagementScores != null ? raw.currentEngagementScores : raw.engagementScores
    );
    var apiLevelNo = toNumber(raw.engagementLevel);
    var apiEntry = findLevelEntry(levels, apiLevelNo);
    var current = apiEntry || resolveLevelByScore(levels, score);
    var currentIndex = findLevelIndex(levels, current.levelNo);
    var isHighest = currentIndex === levels.length - 1;
    var nextLevel = !isHighest && currentIndex >= 0 ? levels[currentIndex + 1] : null;
    var nextMinScore = nextLevel ? nextLevel.minScore : 0;

    return {
      currentLevel: current.levelNo,
      engagementLevelName: current.levelName || (current.levelNo > 0 ? 'L' + current.levelNo : ''),
      isHighestEngagementLevel: isHighest,
      nextLevelScore: isHighest ? current.minScore : nextMinScore,
      scoreToNextLevel: isHighest ? 0 : Math.max(0, nextMinScore - score),
    };
  }

  function normalizeRankPayload(raw) {
    if (!raw || typeof raw !== 'object') return null;

    var levels = normalizeLevelStrategy(raw);
    var derived = levels ? deriveRankFromStrategy(raw, levels) : null;

    var currentLevel = toNumber(raw.engagementLevel);
    var nextLevelMinScore = toNumber(raw.nextLevelMinScore);
    var scoreToNextLevel = toNumber(raw.scoreToNextLevel);
    var isHighestEngagementLevel = isTruthyFlag(raw.isHighestEngagementLevel);
    var engagementLevelName =
      raw.engagementLevelName != null && String(raw.engagementLevelName).trim() !== ''
        ? String(raw.engagementLevelName).trim()
        : '';

    if (derived) {
      var apiLevelInStrategy = findLevelEntry(levels, currentLevel);
      var needsStrategyProgress =
        !isHighestEngagementLevel && nextLevelMinScore <= 0 && levels.length > 0;
      var needsStrategyLevel = currentLevel > 0 && !apiLevelInStrategy;

      if (needsStrategyProgress) {
        currentLevel = derived.currentLevel;
        engagementLevelName = derived.engagementLevelName;
        isHighestEngagementLevel = derived.isHighestEngagementLevel;
        nextLevelMinScore = derived.nextLevelScore;
        scoreToNextLevel = derived.scoreToNextLevel;
      } else {
        if (needsStrategyLevel) {
          currentLevel = derived.currentLevel;
          engagementLevelName = derived.engagementLevelName;
        } else if (!engagementLevelName && derived.engagementLevelName) {
          engagementLevelName = derived.engagementLevelName;
        }
      }
    }

    return {
      enableEngagementLevel: isTruthyFlag(raw.enableEngagementLevel), // 是否开启分层策略；false 时隐藏本 section
      currentLevel: currentLevel, // 当前等级序号，供规则表高亮列匹配 data-tier-level
      engagementLevelName: engagementLevelName, // 当前等级名称，如 L5，用于 Your tier 文案
      isHighestEngagementLevel: isHighestEngagementLevel, // 是否最高等级；true 时进度条满格
      engagementScore: toNumber(
        raw.currentEngagementScores != null ? raw.currentEngagementScores : raw.engagementScores
      ), // 当前活跃度分值
      nextLevelScore: nextLevelMinScore, // 下一级最低分；最高级时为当前等级最低分
      scoreToNextLevel: scoreToNextLevel, // 距下一级还差的分值，用于解锁提示文案
      currentTierCode: engagementLevelName, // 与 engagementLevelName 一致，兼容 __TIER__ 占位替换
    };
  }

  function dispatchRankUpdated(payload) {
    window.__PRR2_LAST_RANK = payload;
    document.dispatchEvent(
      new CustomEvent(RANK_UPDATED_EVENT, {
        detail: payload,
      })
    );
  }

  onReady(function () {
    var root = document.querySelector('.points-rank-v2');
    if (!root) return;

    var i18n = window.PRV2_I18N || {};
    var tierPlaceholder = i18n.tier_placeholder || '__TIER__';

    var elCurrentTier = root.querySelector('.js-prv2-current-tier');
    var elEarnedScores = root.querySelector('.js-prv2-earned-scores');
    var elProgressWrap = root.querySelector('.js-prv2-progress-wrap');
    var elProgressFill = root.querySelector('.js-prv2-progress-fill');
    var elProgressTrack = root.querySelector('.prr2-progress-track');
    var elUnlockText = root.querySelector('.js-prv2-unlock-text');
    var elProgressRatio = root.querySelector('.js-prv2-progress-ratio');

    function showLoading() {
      root.classList.add('is-loading');
      root.setAttribute('aria-busy', 'true');
    }

    function hideLoading() {
      root.classList.remove('is-loading');
      root.setAttribute('aria-busy', 'false');
    }

    function setSectionVisible(visible) {
      root.classList.toggle('prv2--section-hidden', !visible);
    }

    function hideProgress() {
      if (elProgressWrap) elProgressWrap.classList.add('prr2--hidden');
    }

    function renderRank(data) {
      if (!data.enableEngagementLevel) {
        setSectionVisible(false);
        dispatchRankUpdated(data);
        return;
      }

      setSectionVisible(true);

      var tierLabel =
        data.engagementLevelName || data.currentTierCode || (data.currentLevel > 0 ? 'L' + data.currentLevel : '');

      if (elCurrentTier && i18n.your_tier) {
        elCurrentTier.textContent = String(i18n.your_tier).split(tierPlaceholder).join(tierLabel);
      }

      if (elEarnedScores) {
        elEarnedScores.innerHTML =
          escapeHtml(i18n.earned_prefix || '') +
          '<strong>' +
          escapeHtml(String(data.engagementScore)) +
          '</strong>' +
          escapeHtml(i18n.earned_suffix || '');
      }

      if (!elProgressWrap) {
        dispatchRankUpdated(data);
        return;
      }

      if (data.isHighestEngagementLevel) {
        var tierMaxScore = data.nextLevelScore > 0 ? data.nextLevelScore : data.engagementScore;
        elProgressWrap.classList.remove('prr2--hidden');
        if (elProgressFill) elProgressFill.style.width = '100%';
        if (elProgressTrack) {
          elProgressTrack.setAttribute('aria-valuenow', '100');
          elProgressTrack.setAttribute('aria-valuetext', tierMaxScore + ' / ' + tierMaxScore);
        }
        if (elUnlockText) elUnlockText.textContent = '';
        if (elProgressRatio) {
          elProgressRatio.textContent = tierMaxScore + '/' + tierMaxScore;
        }
        dispatchRankUpdated(data);
        return;
      }

      if (data.nextLevelScore <= 0) {
        hideProgress();
        dispatchRankUpdated(data);
        return;
      }

      var targetScore = data.nextLevelScore;
      var scoreToNextLevel =
        data.scoreToNextLevel != null && data.scoreToNextLevel >= 0
          ? data.scoreToNextLevel
          : Math.max(0, targetScore - data.engagementScore);
      var progress = Math.min(100, Math.max(0, (data.engagementScore / targetScore) * 100));

      elProgressWrap.classList.remove('prr2--hidden');
      if (elProgressFill) elProgressFill.style.width = progress + '%';
      if (elProgressTrack) {
        elProgressTrack.setAttribute('aria-valuenow', String(Math.round(progress)));
        elProgressTrack.setAttribute('aria-valuetext', data.engagementScore + ' / ' + targetScore);
      }
      if (elUnlockText) {
        elUnlockText.innerHTML =
          escapeHtml(i18n.unlock_prefix || '') +
          '<strong>' +
          escapeHtml(String(scoreToNextLevel)) +
          '</strong>' +
          escapeHtml(i18n.unlock_suffix || '');
      }
      if (elProgressRatio) {
        elProgressRatio.textContent = data.engagementScore + '/' + targetScore;
      }

      dispatchRankUpdated(data);
    }

    function fetchRankData() {
      showLoading();

      if (USE_MOCK_RANK) {
        return Promise.resolve(MOCK_RANK_RESPONSE)
          .then(function (json) {
            var payload = normalizeRankPayload(json && json.data);
            if (payload) renderRank(payload);
          })
          .finally(hideLoading);
      }

      return fetchPointsData()
        .then(function (data) {
          var payload = normalizeRankPayload(data);
          if (payload) renderRank(payload);
        })
        .catch(function () {
          setSectionVisible(false);
        })
        .finally(hideLoading);
    }

    fetchRankData();
  });
})();
